module.exports = __webpack_public_path__ + "static/media/alanChristopherNeal.bae4f242.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/alanChristopherNeal.jpg
// module id = 1552
// module chunks = 1